export default __webpack_public_path__ + "static/media/mobileGlobalSearch.bf1b6965.svg";